"use client";

import React, { useState } from "react";
import Dialog from "@repo/ui/components/ui/dialog";
import { Table } from "@repo/ui/components/ui/table";
import {
  TableCell,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
} from "@repo/ui/components/ui/table";
import { SizeGuideType } from "@/types/sizeguide";

export default function SizeGuide({
  children,
  data,
}: {
  children: React.ReactNode;
  data: SizeGuideType;
}) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="cursor-pointer" onClick={() => setOpen(true)}>
        {children}
      </div>
      <Dialog open={open} setOpen={setOpen} header="Guida alle taglie">
        <div className="relative pb-5 text-primary-black bg-primary-white">
          <p className="my-10 text-justify">{data.introText}</p>
          {data.tables.map((table, i) => (
            <div key={i}>
              <h4 className="my-10">{table.header}</h4>
              <div className="w-full">
                <div className="rounded-[20px] border overflow-hidden overflow-x-auto">
                  <Table>
                    <TableHeader className="bg-secondary-gray2">
                      <TableRow>
                        {table?.columns &&
                          table?.columns.map((label: string) => (
                            <TableHead
                              className="h-[100px] font-bold text-center"
                              key={label}
                            >
                              {label}
                            </TableHead>
                          ))}
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {table?.data &&
                        table?.data.map((size: any, i: number) => (
                          <TableRow
                            className="even:bg-secondary-gray2 even:h-[60px] odd:bg-primary-white odd:h-[80px]"
                            key={`row-${i}`}
                          >
                            {Object.values(size).map(
                              (value: any, j: number) => (
                                <TableCell
                                  key={`row-${i}-cell-${j}`}
                                  className="font-light text-center"
                                >
                                  {value}
                                </TableCell>
                              ),
                            )}
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Dialog>
    </>
  );
}
